import { gql } from '@apollo/client'

const GET_FLIGHTS = gql`
  query GetFlights($filters: JSON) {
    flights(filters: $filters) {
      collection {
        id
        createdAt
        ticketDocumentNumber
        transactionId
      }
      metadata {
        totalCount
        currentPage
        limitValue
      }
    }
  }
`

export default GET_FLIGHTS
